'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React, { Fragment } from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import UIList from 'UIComponents/list/UIList';
import UITag from 'UIComponents/tag/UITag';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { getAlphaSortedArrOfTextValPairsForSelect, getMultiselectDropdownClass, getMultiselectDropdownOptions, getMultiselectFilterObjAfterRemove, getUnselectedOptions } from '../utils/utils';
import { getMultiselectFilterOptionOrTitleText, getMultiselectMaxText } from '../utils/langUtils';
export default createReactClass({
  displayName: "MultiselectDropdownFilter",
  mixins: [ComponentWithPartials, PureRenderMixin],
  propTypes: {
    className: PropTypes.string,
    defaultOption: PropTypes.string.isRequired,
    disableOptions: PropTypes.bool.isRequired,
    filterType: PropTypes.string.isRequired,
    maxSelections: PropTypes.number,
    onGoodFilterChange: PropTypes.func.isRequired,
    selectedFilters: PropTypes.instanceOf(Immutable.List).isRequired,
    trackMultiselectSelection: PropTypes.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disableOptions: false
    };
  },
  getOptionText: function getOptionText(filter) {
    return getMultiselectFilterOptionOrTitleText(this.props.filterType, filter);
  },
  handleFilterRemoval: function handleFilterRemoval(filterToRemove) {
    var _this$props = this.props,
        filterType = _this$props.filterType,
        onGoodFilterChange = _this$props.onGoodFilterChange,
        selectedFilters = _this$props.selectedFilters;
    return onGoodFilterChange(getMultiselectFilterObjAfterRemove(filterType, selectedFilters, filterToRemove));
  },
  handleFilterSelection: function handleFilterSelection(event) {
    var _this$props2 = this.props,
        filterType = _this$props2.filterType,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        selectedFilters = _this$props2.selectedFilters,
        trackMultiselectSelection = _this$props2.trackMultiselectSelection;
    var newSelection = event.target.value;
    trackMultiselectSelection(filterType, newSelection);
    return onGoodFilterChange(_defineProperty({}, filterType, selectedFilters.push(newSelection)));
  },
  isBelowMaxSelected: function isBelowMaxSelected(maxSelections, allOptions, selectedFilters) {
    if (maxSelections) {
      return selectedFilters.size < maxSelections;
    }

    return selectedFilters.size < Object.keys(allOptions).length;
  },
  renderDropdown: function renderDropdown(allOptions, selectedFilters, defaultOption, filterType, disableOptions) {
    var options = getAlphaSortedArrOfTextValPairsForSelect(getUnselectedOptions(allOptions, selectedFilters), this.getOptionText).map(function (option) {
      return Object.assign({}, option, {
        disabled: disableOptions
      });
    });
    return React.createElement(UISelect, {
      buttonUse: "transparent",
      className: getMultiselectDropdownClass(filterType) + " p-x-0 p-top-0",
      menuWidth: 250,
      onChange: this.handleFilterSelection,
      options: options,
      placeholder: this.getOptionText(defaultOption),
      placement: "bottom right",
      value: null
    });
  },
  renderSelectedFilter: function renderSelectedFilter(filter, index) {
    return React.createElement(UITag, {
      key: index,
      closeable: true,
      onCloseClick: this.partial(this.handleFilterRemoval, filter)
    }, this.getOptionText(filter));
  },
  render: function render() {
    var _this$props3 = this.props,
        className = _this$props3.className,
        defaultOption = _this$props3.defaultOption,
        disableOptions = _this$props3.disableOptions,
        filterType = _this$props3.filterType,
        maxSelections = _this$props3.maxSelections,
        selectedFilters = _this$props3.selectedFilters;
    var allOptions = getMultiselectDropdownOptions(filterType);
    var isBelowMaxSelected = this.isBelowMaxSelected(maxSelections, allOptions, selectedFilters);
    return React.createElement(UIFormControl, {
      className: className,
      label: getMultiselectFilterOptionOrTitleText(filterType, 'fullTitle'),
      help: maxSelections ? getMultiselectMaxText(maxSelections) : null
    }, React.createElement(Fragment, null, selectedFilters.size > 0 && React.createElement(UIList, null, selectedFilters.map(this.renderSelectedFilter)), isBelowMaxSelected ? this.renderDropdown(allOptions, selectedFilters, defaultOption, filterType, disableOptions) : null));
  }
});